import { Link, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Footer.css';

type SupportedLang = 'ko' | 'en';

function resolveLang(raw: string | undefined): SupportedLang {
  return raw === 'en' ? 'en' : 'ko';
}

export function Footer() {
  const { t } = useTranslation('common');
  const { lang: langParam } = useParams<{ lang?: string }>();
  const lang = resolveLang(langParam);

  return (
    <footer className="footer">
      <span className="footer-brand">
        <strong>Race/Map</strong> — {t('footer')}
      </span>
      <nav className="footer-links" aria-label={t('footerLinks.privacy')}>
        <Link to={`/${lang}/privacy`} className="footer-link">
          {t('footerLinks.privacy')}
        </Link>
        <Link to={`/${lang}/terms`} className="footer-link">
          {t('footerLinks.terms')}
        </Link>
      </nav>
    </footer>
  );
}
